<template>
  <van-tabbar v-model="activeTabbar">
    <van-tabbar-item v-for="(item, index) in navList" :to="{name: item.routerName}" :key="index">
      <span>{{item.name}}</span>
      <img
              slot="icon"
              slot-scope="props"
              :src="props.active ? item.active : item.normal"
      >
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
	import {Tabbar, TabbarItem} from 'vant';

	export default {
		data() {
			return {
				activeTabbar: 0,
				navList: [{
					name: '首页',
					routerName: 'Home',
					normal: require('@/common/images/home_icon.png'),
					active: require('@/common/images/home_icon_p.png')
				}, {
					name: '模块一',
					routerName: 'Home',
					normal: require('@/common/images/a_icon.png'),
					active: require('@/common/images/a_icon_p.png')
				}, {
					name: '模块二',
					routerName: 'Home',
					normal: require('@/common/images/a_icon.png'),
					active: require('@/common/images/a_icon_p.png')
				}, {
					name: '我的',
					routerName: 'Mine',
					normal: require('@/common/images/user.png'),
					active: require('@/common/images/user_p.png')
				}]
			}
		},
		created() {
			this.change();
		},
		components: {
			'van-tabbar': Tabbar,
			'van-tabbar-item': TabbarItem
		},
		watch: {
			$route() {
				this.change();
			}
		},
		methods: {
			change() {
				let routerName = this.$route.name;
				this.activeTabbar = this.navList.findIndex(item => {
					return item.routerName === routerName
				});
			}
		}
	}
</script>

<style scoped>

</style>
